import { Component, OnInit } from '@angular/core';
import { VoucherService, VoucherRedeemModel, BalanceService, config, PopulationQuery, ErrorStateService } from '@fgb/core';
import { take } from 'rxjs/operators';
import { Populations } from 'src/app/shared/utilities/populations';
import { firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'fgb-vouchers',
  templateUrl: './vouchers.component.html',
  styleUrls: ['./vouchers.component.scss'],
})
export class VouchersComponent implements OnInit {
  voucherCode: string;
  redemptionResult: string;
  disableButton: boolean;
  sucessfulRedemption: boolean;
  voucherError: { Code: string; Message: string };
  private messageTimeout: NodeJS.Timeout;
  isMobileView = window.innerWidth <= 991;

  isCorporate: boolean;
  populations = Populations;

  constructor(
    private voucherService: VoucherService,
    private balanceService: BalanceService,
    private populationQuery: PopulationQuery,
    public errorService: ErrorStateService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.isCorporate = this.populationQuery.userInPopulation([this.populations.Hospitality]);
  }

  redeemVoucher() {
    if (this.messageTimeout) {
      clearTimeout(this.messageTimeout);
    }
    this.clearMessages();
    this.sucessfulRedemption = false;
    this.disableButton = true;

    if (!this.voucherCode) {
      this.redemptionResult = this.translate.instant('voucher.code.empty.text');
      this.disableButton = false;
      this.clearMessagesAfter(10000);
      return;
    }

    let voucher = new VoucherRedeemModel();
    voucher.VoucherCode = this.voucherCode;
    firstValueFrom(this.voucherService.redeemVoucher(voucher))
      .then((item) => {
        this.balanceService.fetchBalance(config.purseConfig.virtualLoyalty).pipe(take(1)).subscribe();
        this.redemptionResult = this.translate.instant('voucher.process.code');
        this.sucessfulRedemption = true;
      })
      .catch((err) => {
        this.voucherError = err?.error;
      })
      .finally(() => {
        this.disableButton = false;
        this.clearMessagesAfter(10000);
      });
  }

  private clearMessagesAfter(timeAfter: number) {
    this.messageTimeout = setTimeout(() => {
      this.clearMessages();
    }, timeAfter);
  }

  clearMessages() {    
    this.redemptionResult = '';
    this.errorService.clearErrors();
  }
}
